export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  matchCount: number;
}

export const categories: Category[] = [
  {
    slug: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '全球顶级足球赛事，英超、西甲、欧冠、世界杯等精彩足球资讯与实时数据',
    matchCount: 128,
  },
  {
    slug: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲联赛等篮球赛事全覆盖，实时比分与深度分析',
    matchCount: 96,
  },
  {
    slug: 'tennis',
    name: '网球',
    icon: 'ri-base-station-line',
    description: 'ATP、WTA巡回赛，大满贯赛事全程跟踪，网球爱好者首选平台',
    matchCount: 64,
  },
  {
    slug: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS2、王者荣耀等顶级电竞赛事资讯与数据',
    matchCount: 156,
  },
  {
    slug: 'others',
    name: '综合',
    icon: 'ri-trophy-line',
    description: 'F1赛车、斯诺克、高尔夫、拳击、综合格斗等更多精彩体育赛事',
    matchCount: 88,
  },
];

export const categoryMap: Record<string, Category> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});